<template>
  <div class="login-wrapper">
    <!-- Background -->
    <div class="bg-image"></div>
    <div class="bg-overlay"></div>

    <b-container fluid class="h-100">
      <b-row class="h-100 no-gutters">
        <!-- LEFT SIDE — LOGO + TEXT -->
        <b-col
          cols="12"
          lg="6"
          class="d-flex flex-column justify-content-center text-left px-5pc left-info"
        >
          <div class="left-content">
            <img src="~@/assets/img/brand/logo_abitue_white.png" />

            <h1 class="slide-title text-white mt-5">
              O futuro do seu restaurante começa aqui
            </h1>

            <p class="slide-text text-white">
              Compreenda comportamentos, crie campanhas, controle gastos e faça
              cross sell entre os seus restaurantes num só sítio.
            </p>
          </div>
        </b-col>

        <!-- RIGHT SIDE — RESET CARD -->
        <b-col
          cols="12"
          lg="6"
          class="d-flex align-items-center justify-content-center right-side"
        >
          <div class="login-card shadow-lg p-5">
            <p class="font-weight-bold small mb-1">RECUPERAR ACESSO</p>
            <h2 class="font-weight-bold mb-4">Crie uma nova password</h2>

            <validation-observer ref="formValidator">
              <b-form @submit.prevent="onSubmit">
                <base-input
                  alternative
                  class="mb-3"
                  name="Password"
                  :rules="{ required: true, min: 6 }"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  placeholder="Nova password"
                  v-model="form.password"
                />

                <base-input
                  alternative
                  class="mb-3"
                  name="Confirmar Password"
                  :rules="{ required: true, confirmed: form.password }"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  placeholder="Confirmar password"
                  v-model="form.confirmPassword"
                />

                <p class="error">{{ error }}</p>

                <base-button
                  type="primary"
                  native-type="submit"
                  class="btn-login"
                >
                  Continuar
                </base-button>
              </b-form>
            </validation-observer>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import api from "@/api";

  export default {
    data() {
      return {
        error: "",
        form: {
          password: "",
          confirmPassword: "",
        },
        token: null,
      };
    },

    mounted() {
      this.token = this.$route.query.token;
    },

    methods: {
      validarPassword(pass) {
        const regex =
          /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}[\]|:;"'<>,.?/]).{6,}$/;
        return regex.test(pass);
      },

      async onSubmit() {
        this.error = "";

        if (!this.token) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: "O token está inválido ou expirou.",
          });
          return;
        }
        if (!this.validarPassword(this.form.password)) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message:
              "A password deve ter pelo menos 1 letra maiúscula, 1 número e 1 símbolo.",
          });
          return;
        }
        if (this.form.password !== this.form.confirmPassword) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: "As passwords não coincidem.",
          });
          return;
        }

        try {
          await api.post("/auth/reset-password", {
            token: this.token,
            password: this.form.password,
          });

          this.form.password = "";
          this.form.confirmPassword = "";
          this.$router.push("/login");
        } catch (err) {
          this.$notify({
            type: "danger",
            title: "Erro",
            message:
              err.response?.data?.error ||
              "Não foi possível redefinir a password.",
          });
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .login-wrapper {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }
  .px-5pc {
    padding-left: 10% !important;
    padding-right: 10% !important;
  }
  .bg-image {
    position: absolute;
    inset: 0;
    background-image: url("~@/assets/img/auth/recuperar-bg.png") !important;
    background-size: cover;
    background-position: center;
    z-index: 1;
  }
  .bg-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(2px);
    z-index: 2;
  }
  .left-info {
    z-index: 3;
    color: #fff;
  }
  .left-content {
    max-width: 100%;
  }
  .slide-title {
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 15px;
  }
  .slide-text {
    font-size: 18px;
    opacity: 0.85;
  }
  .right-side {
    z-index: 3;
  }
  .login-card {
    width: 420px;
    background: #ffffff;
    border-radius: 18px;
  }
  .btn-login {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 15px;
    border-radius: 10px !important;
    background: #000 !important;
    border: none !important;
  }
  p.error {
    color: red;
    font-size: 14px !important;
    font-weight: 600;
  }
  .invalid-feedback {
    display: none !important;
  }
  .navbar {
    display: none;
  }
</style>
